/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 398);
/******/ })
/************************************************************************/
/******/ ({

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(399);


/***/ }),

/***/ 399:
/***/ (function(module, exports) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils;


Component.register("simple-text", function (_Component) {
  _inherits(SimpleText, _Component);

  function SimpleText(config) {
    _classCallCheck(this, SimpleText);

    var _this = _possibleConstructorReturn(this, (SimpleText.__proto__ || Object.getPrototypeOf(SimpleText)).call(this, config));

    Utils.assignWithDefaults(_this, {
      text: null,
      maxLines: null
    }, _this.config);
    return _this;
  }

  _createClass(SimpleText, [{
    key: "layout",
    value: function layout(parentNode) {
      _get(SimpleText.prototype.__proto__ || Object.getPrototypeOf(SimpleText.prototype), "layout", this).call(this, parentNode);

      DOMUtils.empty(this.parentNode);
      var el = document.createElement("div");
      el.classList.add("simple-text");
      el.innerHTML = this.text;
      this.parentNode.appendChild(el);

      if (Utils.type(this.maxLines) === "number" && this.maxLines >= 1) {
        var _$exec = /(.+)px/.exec(DOMUtils.getCSSProperty(el, "font-size")),
            _$exec2 = _slicedToArray(_$exec, 2),
            _ = _$exec2[0],
            fontSize = _$exec2[1];

        if (!fontSize) {
          this.error("Can't apply max lines, font-size not in px units");
          return;
        }

        fontSize = Number(fontSize);
        if (this.maxLines === 1) {
          el.style.whiteSpace = "nowrap";
          var parentWidth = this.parentNode.clientWidth;
          while (el.scrollWidth > parentWidth && fontSize > 0) {
            el.style.fontSize = (fontSize -= 1) + "px";
          }
        } else {
          var html = el.innerHTML;
          var height = el.scrollHeight;
          el.innerHTML = html + "<br><br>";
          var maxHeight = (el.scrollHeight - height) * this.maxLines;
          el.innerHTML = html;
          while (el.scrollHeight > maxHeight && fontSize > 0) {
            el.style.fontSize = (fontSize -= 1) + "px";
          }
        }
      }
    }
  }, {
    key: "load",
    value: function load() {}
  }, {
    key: "resize",
    value: function resize() {}
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {}
  }, {
    key: "restart",
    value: function restart() {}
  }]);

  return SimpleText;
}(Component));

/***/ })

/******/ });


// WEBPACK FOOTER //
// simple-text-1e08b0f4998069f7371f.js